import { render, staticRenderFns } from "./accountSafe.vue?vue&type=template&id=d90ed6ae&"
import script from "./accountSafe.vue?vue&type=script&lang=js&"
export * from "./accountSafe.vue?vue&type=script&lang=js&"
import style0 from "./accountSafe.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports